<template>
  <div class="import-content">
    <butn v-permission="butnPremission" :btntype="btnType" :title="butnTitle" @click="importExcel"></butn>
    <el-dialog v-if="showImportModal" class="rc-dialog" :title="modalTitle || butnTitle" :visible.sync="showImportModal"
      @close="closeDialog" :close-on-click-modal="false" destroy-on-close width="45%">
      <el-form ref="curdForm" size="small" :model="form" :rules="rules" label-position="right" label-width="120px">
        <el-form-item v-if="showLeaderType" label="核对管理主体：" prop="leaderType">
          <el-select class="select-item" v-model="form.leaderType" placeholder="请选择核对管理主体范围" size="small"
            collapse-tags clearable>
            <el-option v-for="(item, i) in leaderTypeData" :key="i" :label="item.paramValue"
              :value="Number(item.paramKey)">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item v-if="downloadTemplate && downloadTemplate.length > 0">
          <butn btntype="primary" title="下载模板" @click="clickDownloadTemplate"></butn>
        </el-form-item>

        <el-form-item label="附件：" prop="file">
          <upload v-model="form.file" ref="removeFile" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <butn @click="closeDialog" title="取消"></butn>
        <butn btntype="primary" @click="comfirm" title="确定"></butn>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import butn from "@/components/button/index";
import Upload from "@/components/upload/excel";
import { downloadByUrl } from "@/utils/common";
import { getBusinessParamByTypes } from "@/api/sysParam";
import { getItem } from "@/utils/storage";
export default {
  components: { butn, Upload },
  data() {
    return {
      form: {
        file: null,
        
      },
      rules: {
        leaderType: [
          {
            required: true,
            message: "请选择核对管理主体",
            trigger: "change"
          }
        ],
        file: [
          {
            required: true,
            message: "请上传附件",
            trigger: "change"
          }
        ],
      },
      showImportModal: false,
      leaderTypeData: [],
    };
  },
  props: {
    btnType: {
      type: String,
      default: "primary",
    },
    butnPremission: {
      type: String,
      default: "",
    },
    butnTitle: {
      type: String,
      default: "导入",
    },
    modalTitle: {
      type: String,
      default: null,
    },
    jumpExcelError: {
      type: Boolean,
      default: true,
    },
    downloadTemplate: {
      type: String,
      default: "",
    },
    classId: {
      type: String,
      default: "",
    },
    importApi: Function,
    showLeaderType: {
      type: Boolean,
      default: false,
    },
    isShowAsyncConfirm: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    let Types = [];
    if (this.showLeaderType) {
      Types.push("USER_LEADER_TYPE")
      this.form = {
        ...this.form,
        leaderType: ''
      }
    }
    if (Types.length) {
      const deptLevelCode = getItem("deptLevelCode");
      getBusinessParamByTypes({types: Types, deptLevelCode}).then((res) => {
        if (!res || res.code != 0) return;
        this.leaderTypeData = res.data["USER_LEADER_TYPE"]
      })
    }
  },
  methods: {
    importExcel() {
      this.showImportModal = true;
    },

    comfirm() {
      if (!this.importApi) return
      this.$refs.curdForm.validate(async (valid) => {
        if (valid) {
          this.loading = true;
          let formData = new FormData();
          // 遍历 form 对象，将所有属性添加到 formData 中
          for (let key in this.form) {
            if (this.form.hasOwnProperty(key)) {
              // 处理数组类型的字段（如 leaderType）
              if (Array.isArray(this.form[key])) {
                this.form[key].forEach((value) => {
                  formData.append(key, value);
                });
              } else {
                formData.append(key, this.form[key]);
              }
            }
          }
          if (this.classId) {
            formData.append("classId", this.classId);
          }
          this.importApi(formData).then((res) => {
            this.loading = false;
            if (res && res.code == 0) {
              if (res.data != null) {
                const { errorImportExcelVoList = null } = res.data;
                if (!errorImportExcelVoList || errorImportExcelVoList.length === 0) {
                  if (this.isShowAsyncConfirm) {
                    this.$confirm('数据正在核对中，请稍后点击“查看详情”查看核对结果', '提示', {
                      confirmButtonText: '确定',
                      showCancelButton: false,
                      type: 'warning'
                    }).then(() => {
                      this.$emit("importSuccess");
                      this.closeDialog();
                    });
                  } else {
                    this.toErrorPath(res.data)
                  }
                } else {
                  this.toErrorPath(res.data)
                }
              } else {
                this.$message.success(res.msg);
                this.$emit("importSuccess");
                this.closeDialog();
              }
            } else {
              this.$refs.removeFile.$refs.upload.uploadFiles.pop();
              this.form.file = null;
            }
          });
        }
      });
    },
    toErrorPath(data) {
      this.$message.error("导入包含错误数据，请检查");
      this.$router.push({
        path: "/excelError",
      });
      localStorage.setItem("errorExcelData", JSON.stringify(data));
      this.closeDialog();
    },
    closeDialog() {
      this.showImportModal = false;
      // 数据重置
      this.form.file = null
      if (this.showLeaderType) {
        this.form.leaderType = ''
      }
      // 清空上传组件中的文件列表
      if (this.$refs.removeFile && this.$refs.removeFile.$refs.upload) {
        this.$refs.removeFile.$refs.upload.uploadFiles = [];
      }
    },

    clickDownloadTemplate() {
      downloadByUrl('', this.downloadTemplate)
    },
  },
};
</script>

<style lang="scss" scoped>
.import-content {
  display: inline;
}
</style>
